<template>
  <header class="header">
    <img
      src="@assets/images/brand/santander-arena-lockup-red.png"
      alt="Santander Arena"
      class="header__logo"
    >
    <span
      v-if="loading"
      class="header__spinner header-spinner"
    />
    <div class="header__pendings">
      <div
        class="header__notifications"
        @click="onNotificationClicked()"
      >
        {{ pendingsCount }}
      </div>
    </div>
    <div class="header__user">
      <div class="header-user">
        <div
          class="header-user__identification"
          @mouseover="showNavigation()"
          @mouseleave="hideNavigation()"
        >
          <div class="header-user__name">
            {{ userName }}
          </div>
          <div class="header-user__account-icon" />
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import * as actions from '../store/action-types';

export default {
  name: 'HeaderUser',
  props: {
    userName: {
      type: String,
      default: () => '',
    },
    userEmail: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    pendingsCount() {
      return this.$store.state.calendar.duels.length + this.$store.state.calendar.transferAttempts.length;
    },
    loading() {
      return this.$store.state.calendar.fetching;
    },
  },
  mounted() {
    this.hideNavigation();
  },
  methods: {
    onNotificationClicked() {
      this.$store.dispatch(actions.TOGGLE_PENDINGS);
    },
    // The navigation dropdown is rendered by calendar-page; pages like /faq
    // mount this header without it (pre-existing: this threw on Vue 2 too).
    showNavigation() {
      const navigation = document.getElementById('headerUserNavigation');
      if (navigation) navigation.style.display = 'block';
    },
    hideNavigation() {
      const navigation = document.getElementById('headerUserNavigation');
      if (navigation) navigation.style.display = 'none';
    },
  },
};
</script>
<style scoped>
.header-spinner {
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 2px solid #ec0000;
  border-bottom-color: transparent;
  border-radius: 50%;
  animation: header-spin 0.75s linear infinite;
}

@keyframes header-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
